import { marketplaceConstants } from "../_constants";
import { marketplaceService } from "../_services";
import { alertActions } from ".";

export const marketplaceAction = {
  getAllMarketplaces,
  configureMarketplace,
  activeCloudStorage,
  getListInfraByMarketplaceId
};

function getAllMarketplaces() {
  return (dispatch) => {
    dispatch(request());
    marketplaceService.getAllMarketplaces().then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_REQUEST };
  }
  function success(data) {
    return {
      type: marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_FAILURE,
      error,
    };
  }
}

function configureMarketplace(formData) {
  return (dispatch) => {
    dispatch(request());
    marketplaceService.configureMarketplace(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: marketplaceConstants.CONFIGURE_MARKETPLACE_REQUEST };
  }
  function success(data) {
    return {
      type: marketplaceConstants.CONFIGURE_MARKETPLACE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: marketplaceConstants.CONFIGURE_MARKETPLACE_FAILURE,
      error,
    };
  }
}

function activeCloudStorage(type) {
  return (dispatch) => {
    dispatch(request());
    marketplaceService.activeCloudStorage(type).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: marketplaceConstants.ACTIVE_CLOUD_STORAGE_REQUEST };
  }
  function success(data) {
    return {
      type: marketplaceConstants.ACTIVE_CLOUD_STORAGE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: marketplaceConstants.ACTIVE_CLOUD_STORAGE_FAILURE,
      error,
    };
  }
}

function getListInfraByMarketplaceId(marketplaceId) {
  return (dispatch) => {
    dispatch(request());
    marketplaceService.getListInfraByMarketplaceId(marketplaceId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_FAILURE,
      error,
    };
  }
}